import { render, staticRenderFns } from "./PublicationEditableItemText.vue?vue&type=template&id=151847b2&scoped=true&lang=pug"
import script from "./PublicationEditableItemText.vue?vue&type=script&lang=js"
export * from "./PublicationEditableItemText.vue?vue&type=script&lang=js"
import style0 from "./PublicationEditableItemText.vue?vue&type=style&index=0&id=151847b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151847b2",
  null
  
)

export default component.exports